// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/morgans.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { BackfillAgencyGraphRequest, BackfillAgencyGraphResponse, BackfillSummariesRequest, BackfillSummariesResponse, CreateTrackingProfileRequest, CreateTrackingProfileResponse, DeleteTrackingProfileRequest, DeleteTrackingProfileResponse, DismissMatchRequest, DismissMatchResponse, GenerateSummaryRequest, GenerateSummaryResponse, GetAlertStatusRequest, GetAlertStatusResponse, GetHealthRequest, GetHealthResponse, GetMatchesRequest, GetMatchesResponse, GetMatchStatsRequest, GetMatchStatsResponse, GetOpportunityHistoryRequest, GetOpportunityHistoryResponse, GetOpportunityRequest, GetOpportunityResponse, GetSavedStatusRequest, GetSavedStatusResponse, GetScrapeStatusRequest, GetScrapeStatusResponse, GetSimilarOpportunitiesRequest, GetSimilarOpportunitiesResponse, GetTrackingProfileRequest, GetTrackingProfileResponse, IngestSamOpportunitiesRequest, IngestSamOpportunitiesResponse, IngestUsaspendingAwardsRequest, IngestUsaspendingAwardsResponse, IngestUsaspendingVehiclesRequest, IngestUsaspendingVehiclesResponse, ListOpportunitiesRequest, ListOpportunitiesResponse, ListTrackingProfilesRequest, ListTrackingProfilesResponse, MarkMatchViewedRequest, MarkMatchViewedResponse, PreviewMatchesRequest, PreviewMatchesResponse, SaveMatchRequest, SaveMatchResponse, SearchOpportunitiesRequest, SearchOpportunitiesResponse, SetAlertRequest, SetAlertResponse, SetSavedRequest, SetSavedResponse, TriggerMatchRequest, TriggerMatchResponse, TriggerScrapeRequest, TriggerScrapeResponse, UpdateTrackingProfileRequest, UpdateTrackingProfileResponse } from "./morgans_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * MorgansService provides SAM.gov opportunity scraping, search, and profile matching.
 *
 * @generated from service mono.morgans.v1.MorgansService
 */ export const MorgansService = {
    typeName: "mono.morgans.v1.MorgansService",
    methods: {
        /**
     * TriggerScrape manually initiates a SAM.gov scrape job.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.TriggerScrape
     */ triggerScrape: {
            name: "TriggerScrape",
            I: TriggerScrapeRequest,
            O: TriggerScrapeResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetScrapeStatus returns the status of the last or current scrape job.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetScrapeStatus
     */ getScrapeStatus: {
            name: "GetScrapeStatus",
            I: GetScrapeStatusRequest,
            O: GetScrapeStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListOpportunities returns paginated opportunities with filtering.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListOpportunities
     */ listOpportunities: {
            name: "ListOpportunities",
            I: ListOpportunitiesRequest,
            O: ListOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetOpportunity returns a single opportunity by notice ID.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetOpportunity
     */ getOpportunity: {
            name: "GetOpportunity",
            I: GetOpportunityRequest,
            O: GetOpportunityResponse,
            kind: MethodKind.Unary
        },
        /**
     * SearchOpportunities performs semantic search over opportunities.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SearchOpportunities
     */ searchOpportunities: {
            name: "SearchOpportunities",
            I: SearchOpportunitiesRequest,
            O: SearchOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GenerateSummary generates or regenerates an AI summary for an opportunity.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GenerateSummary
     */ generateSummary: {
            name: "GenerateSummary",
            I: GenerateSummaryRequest,
            O: GenerateSummaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * BackfillSummaries batch generates summaries for opportunities missing them.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.BackfillSummaries
     */ backfillSummaries: {
            name: "BackfillSummaries",
            I: BackfillSummariesRequest,
            O: BackfillSummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetOpportunityHistory returns all versions of an opportunity grouped by solicitation number or title.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetOpportunityHistory
     */ getOpportunityHistory: {
            name: "GetOpportunityHistory",
            I: GetOpportunityHistoryRequest,
            O: GetOpportunityHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSimilarOpportunities finds similar opportunities using semantic search with deduplication and timeline building.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetSimilarOpportunities
     */ getSimilarOpportunities: {
            name: "GetSimilarOpportunities",
            I: GetSimilarOpportunitiesRequest,
            O: GetSimilarOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSavedStatus returns whether an opportunity is saved by the current user.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetSavedStatus
     */ getSavedStatus: {
            name: "GetSavedStatus",
            I: GetSavedStatusRequest,
            O: GetSavedStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetSaved explicitly saves or unsaves an opportunity for a user with optional notes.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SetSaved
     */ setSaved: {
            name: "SetSaved",
            I: SetSavedRequest,
            O: SetSavedResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetAlertStatus returns whether alerts are enabled for an opportunity by the current user.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetAlertStatus
     */ getAlertStatus: {
            name: "GetAlertStatus",
            I: GetAlertStatusRequest,
            O: GetAlertStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetAlert explicitly enables or disables alerts for an opportunity (100 per user limit).
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SetAlert
     */ setAlert: {
            name: "SetAlert",
            I: SetAlertRequest,
            O: SetAlertResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreateTrackingProfile creates a new tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.CreateTrackingProfile
     */ createTrackingProfile: {
            name: "CreateTrackingProfile",
            I: CreateTrackingProfileRequest,
            O: CreateTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateTrackingProfile updates an existing tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.UpdateTrackingProfile
     */ updateTrackingProfile: {
            name: "UpdateTrackingProfile",
            I: UpdateTrackingProfileRequest,
            O: UpdateTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteTrackingProfile deletes a tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.DeleteTrackingProfile
     */ deleteTrackingProfile: {
            name: "DeleteTrackingProfile",
            I: DeleteTrackingProfileRequest,
            O: DeleteTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListTrackingProfiles returns tracking profiles for a user.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.ListTrackingProfiles
     */ listTrackingProfiles: {
            name: "ListTrackingProfiles",
            I: ListTrackingProfilesRequest,
            O: ListTrackingProfilesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetTrackingProfile returns a single tracking profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetTrackingProfile
     */ getTrackingProfile: {
            name: "GetTrackingProfile",
            I: GetTrackingProfileRequest,
            O: GetTrackingProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * TriggerMatch runs matching for all active profiles against recent opportunities.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.TriggerMatch
     */ triggerMatch: {
            name: "TriggerMatch",
            I: TriggerMatchRequest,
            O: TriggerMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * PreviewMatches previews matches for a profile without persisting.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.PreviewMatches
     */ previewMatches: {
            name: "PreviewMatches",
            I: PreviewMatchesRequest,
            O: PreviewMatchesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetMatches returns persisted matches for a profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetMatches
     */ getMatches: {
            name: "GetMatches",
            I: GetMatchesRequest,
            O: GetMatchesResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetMatchStats returns match statistics for a profile.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetMatchStats
     */ getMatchStats: {
            name: "GetMatchStats",
            I: GetMatchStatsRequest,
            O: GetMatchStatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * MarkMatchViewed marks a match as viewed.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.MarkMatchViewed
     */ markMatchViewed: {
            name: "MarkMatchViewed",
            I: MarkMatchViewedRequest,
            O: MarkMatchViewedResponse,
            kind: MethodKind.Unary
        },
        /**
     * DismissMatch dismisses a match.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.DismissMatch
     */ dismissMatch: {
            name: "DismissMatch",
            I: DismissMatchRequest,
            O: DismissMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * SaveMatch saves/bookmarks a match.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.SaveMatch
     */ saveMatch: {
            name: "SaveMatch",
            I: SaveMatchRequest,
            O: SaveMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetHealth returns service health information.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.GetHealth
     */ getHealth: {
            name: "GetHealth",
            I: GetHealthRequest,
            O: GetHealthResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestUsaspendingAwards (Phase 1c) pulls awarded-contract records from the
     * public USAspending API, normalizes them into GovCon knowledge-graph
     * entities (company + awarding-agency org chart), and idempotently upserts
     * them into pangaea's GovconGraphGatewayService — reconciling company nodes
     * against ryugu CompanyProfiles by UEI.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestUsaspendingAwards
     */ ingestUsaspendingAwards: {
            name: "IngestUsaspendingAwards",
            I: IngestUsaspendingAwardsRequest,
            O: IngestUsaspendingAwardsResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestSamOpportunities (Phase 1c) pulls SAM.gov notices for a posted-date
     * window, normalizes the awarding-office hierarchy + awardee into GovCon
     * graph entities (source=SAM.gov; same nodes as USAspending, competing
     * edges), and idempotently upserts them.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestSamOpportunities
     */ ingestSamOpportunities: {
            name: "IngestSamOpportunities",
            I: IngestSamOpportunitiesRequest,
            O: IngestSamOpportunitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * IngestUsaspendingVehicles (Phase 1c) pulls USAspending IDV awards (contract
     * vehicles), normalizes each into a vehicle node + vehicle_holder edge from
     * its recipient + placement under its awarding agency, and idempotently
     * upserts them — reconciling vehicle nodes to ryugu ContractVehicle by PIID.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.IngestUsaspendingVehicles
     */ ingestUsaspendingVehicles: {
            name: "IngestUsaspendingVehicles",
            I: IngestUsaspendingVehiclesRequest,
            O: IngestUsaspendingVehiclesResponse,
            kind: MethodKind.Unary
        },
        /**
     * BackfillAgencyGraph (Phase 1c-3) walks an agency's USAspending history into
     * the graph in one shot: contract awards (companies + org chart) then IDV
     * awards (vehicles + holders). Idempotent — re-running does not duplicate.
     *
     * @generated from rpc mono.morgans.v1.MorgansService.BackfillAgencyGraph
     */ backfillAgencyGraph: {
            name: "BackfillAgencyGraph",
            I: BackfillAgencyGraphRequest,
            O: BackfillAgencyGraphResponse,
            kind: MethodKind.Unary
        }
    }
};
